class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector('[data-predictive-search]');
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';

    this.setupEventListeners();
  }

  setupEventListeners() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('focus', this.onFocus.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.addEventListener('keyup', this.onKeyup.bind(this));
    this.addEventListener('keydown', this.onKeydown.bind(this));
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    super.onChange();
    const newSearchTerm = this.getQuery();
    if (!this.searchTerm || !newSearchTerm.startsWith(this.searchTerm)) {
      // Remove the results when they are no longer relevant for the new search term
      // so they don't show up when the dropdown opens again
      this.querySelector('#predictive-search-results-groups-wrapper')?.remove();
    }

    // Update the term asap, don't wait for the predictive search query to finish loading
    //this.updateSearchForTerm(this.searchTerm, newSearchTerm);

    this.searchTerm = newSearchTerm;

    if (this.searchTerm.length < 2) {
  this.close(false);
  return;
}

    this.getSearchResults(this.searchTerm);
  }

  // highlight predictive search
        highlightMatchingTerms() {
  const searchTerm = this.getQuery().trim();
  if (!searchTerm || !this.predictiveSearchResults) return;

  const terms = searchTerm
    .split(/\s+/)
    .map((term) => term.trim())
    .filter(Boolean)
    .sort((a, b) => b.length - a.length);

  if (!terms.length) return;

  const selectors = [
  '.predictive-search__item-heading',
  '.predictive-search__item-vendor',
  '.predictive-search__item-query-result',
  '.predictive-search__item-content span',
  '.be-exact-sku-match span'
];
  const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const regex = new RegExp(`(${terms.map(escapeRegExp).join('|')})`, 'gi');

  selectors.forEach((selector) => {
    this.predictiveSearchResults.querySelectorAll(selector).forEach((el) => {
      // Avoid highlighting the same element twice
      if (el.dataset.highlighted === 'true') return;

      const walker = document.createTreeWalker(
        el,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode(node) {
            if (!node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
            if (node.parentElement?.closest('mark')) return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        }
      );

      const textNodes = [];
      while (walker.nextNode()) {
        textNodes.push(walker.currentNode);
      }

      textNodes.forEach((textNode) => {
        const text = textNode.nodeValue;
        if (!regex.test(text)) {
          regex.lastIndex = 0;
          return;
        }

        regex.lastIndex = 0;

        const fragment = document.createDocumentFragment();
        let lastIndex = 0;

        text.replace(regex, (match, _group, offset) => {
          if (offset > lastIndex) {
            fragment.appendChild(document.createTextNode(text.slice(lastIndex, offset)));
          }

          const mark = document.createElement('mark');
          mark.className = 'predictive-search__match';
          mark.textContent = match;
          fragment.appendChild(mark);

          lastIndex = offset + match.length;
        });

        if (lastIndex < text.length) {
          fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
        }

        textNode.parentNode.replaceChild(fragment, textNode);
      });

      el.dataset.highlighted = 'true';
    });
  });
}
    // end highlight predictive search

  onFormSubmit(event) {
    if (!this.getQuery().length || this.querySelector('[aria-selected="true"] a')) event.preventDefault();
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }

  onFocus() {
    const currentSearchTerm = this.getQuery();

    if (!currentSearchTerm.length) return;

    if (this.searchTerm !== currentSearchTerm) {
      // Search term was changed from other search input, treat it as a user change
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }
/*
  onKeyup(event) {
    if (!this.getQuery().length) this.close(true);
    event.preventDefault();

    switch (event.code) {
      case 'ArrowUp':
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case 'Enter':
        this.selectOption();
        break;
    }
  }*/
 onKeyup(event) {
  const query = this.getQuery();

  if (!query.length) {
    this.close(true);
    return;
  }

  switch (event.code) {
    case 'ArrowUp':
      event.preventDefault();
      this.switchOption('up');
      break;

    case 'ArrowDown':
      event.preventDefault();
      this.switchOption('down');
      break;

    case 'Enter':
      event.preventDefault();
      this.selectOption();
      break;

    default:
      // Let normal typing behave normally
      break;
  }
}
/** fix for second char ^^ */

  onKeydown(event) {
    // Prevent the cursor from moving in the input when using the up and down arrow keys
    if (event.code === 'ArrowUp' || event.code === 'ArrowDown') {
      event.preventDefault();
    }
  }

  updateSearchForTerm(previousTerm, newTerm) {
    const searchForTextElement = this.querySelector('[data-predictive-search-search-for-text]');
    const currentButtonText = searchForTextElement?.innerText;
    if (currentButtonText) {
      if (currentButtonText.match(new RegExp(previousTerm, 'g')).length > 1) {
        // The new term matches part of the button text and not just the search term, do not replace to avoid mistakes
        return;
      }
      const newButtonText = currentButtonText.replace(previousTerm, newTerm);
      searchForTextElement.innerText = newButtonText;
    }
  }

  switchOption(direction) {
    if (!this.getAttribute('open')) return;

    const moveUp = direction === 'up';
    const selectedElement = this.querySelector('[aria-selected="true"]');

    // Filter out hidden elements (duplicated page and article resources) thanks
    // to this https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/offsetParent
    const allVisibleElements = Array.from(this.querySelectorAll('li, button.predictive-search__item')).filter(
      (element) => element.offsetParent !== null
    );
    let activeElementIndex = 0;

    if (moveUp && !selectedElement) return;

    let selectedElementIndex = -1;
    let i = 0;

    while (selectedElementIndex === -1 && i <= allVisibleElements.length) {
      if (allVisibleElements[i] === selectedElement) {
        selectedElementIndex = i;
      }
      i++;
    }

    this.statusElement.textContent = '';

    if (!moveUp && selectedElement) {
      activeElementIndex = selectedElementIndex === allVisibleElements.length - 1 ? 0 : selectedElementIndex + 1;
    } else if (moveUp) {
      activeElementIndex = selectedElementIndex === 0 ? allVisibleElements.length - 1 : selectedElementIndex - 1;
    }

    if (activeElementIndex === selectedElementIndex) return;

    const activeElement = allVisibleElements[activeElementIndex];

    activeElement.setAttribute('aria-selected', true);
    if (selectedElement) selectedElement.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', activeElement.id);
  }

  selectOption() {
    const selectedOption = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');

    if (selectedOption) selectedOption.click();
  }
/*
  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(' ', '-').toLowerCase();
    this.setLiveRegionLoadingState();

    if (this.cachedResults[queryKey]) {
      this.renderSearchResults(this.cachedResults[queryKey]);
      return;
    }

    fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last&resources[options][fields]=variants.sku,title,variants.title,product_type,vendor&section_id=predictive-search`, {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector('#shopify-section-predictive-search').innerHTML;
        // Save bandwidth keeping the cache in all instances synced
        this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
          predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
        });
        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        if (error?.code === 20) {
          // Code 20 means the call was aborted
          return;
        }
        this.close();
        throw error;
      });
  }
*/
//test
getSearchResults(searchTerm) {
  const queryKey = searchTerm.replace(/\s+/g, '-').toLowerCase();
  this.setLiveRegionLoadingState();

  if (this.cachedResults[queryKey]) {
    this.renderSearchResults(this.cachedResults[queryKey]);
    return;
  }

  const buildUrl = (term) => {
    return `${routes.predictive_search_url}?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last&resources[options][fields]=tag,variants.sku,title,variants.title,product_type,vendor&section_id=predictive-search`;
  };

  const getFallbackQueries = (term) => {
    const words = term
      .trim()
      .split(/\s+/)
      .filter(Boolean);

    const queries = [];
    const seen = new Set();

    const addQuery = (q) => {
      const normalized = q.trim().replace(/\s+/g, ' ').toLowerCase();
      if (!normalized || seen.has(normalized)) return;
      seen.add(normalized);
      queries.push(q.trim().replace(/\s+/g, ' '));
    };

    addQuery(term);

    if (words.length > 1) {
      const skuFirst = [
        ...words.filter((w) => /^[A-Z0-9-]+$/.test(w)),
        ...words.filter((w) => !/^[A-Z0-9-]+$/.test(w)),
      ].join(' ');
      addQuery(skuFirst);

      const sorted = [...words].sort((a, b) => a.localeCompare(b)).join(' ');
      addQuery(sorted);

      const reversed = [...words].reverse().join(' ');
      addQuery(reversed);

      // rotate each word to the front once
      for (let i = 1; i < words.length; i++) {
        addQuery([...words.slice(i), ...words.slice(0, i)].join(' '));
      }
    }

    return queries;
  };

  const getResultsInfo = (text) => {
    const doc = new DOMParser().parseFromString(text, 'text/html');
    const section = doc.querySelector('#shopify-section-predictive-search');

    if (!section) {
      return { markup: '', productCount: 0 };
    }

    const markup = section.innerHTML;

    const productCount =
      section.querySelectorAll('#predictive-search-results-products-list .predictive-search__list-item').length ||
      section.querySelectorAll('.predictive-search__list-item').length;

    return { markup, productCount };
  };

  const queriesToTry = getFallbackQueries(searchTerm);

  const tryFetch = (index = 0) => {
    if (index >= queriesToTry.length) {
      this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
        predictiveSearchInstance.cachedResults[queryKey] = '';
      });
      this.renderSearchResults('');
      return;
    }

    fetch(buildUrl(queriesToTry[index]), {
      signal: this.abortController.signal,
    })
      .then((response) => {
        if (!response.ok) {
          const error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const { markup, productCount } = getResultsInfo(text);

        if (productCount > 0 || index === queriesToTry.length - 1) {
          this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
            predictiveSearchInstance.cachedResults[queryKey] = markup;
          });
          this.renderSearchResults(markup);
          return;
        }

        tryFetch(index + 1);
      })
      .catch((error) => {
        if (error?.code === 20) {
          return;
        }
        this.close();
        throw error;
      });
  };

  tryFetch();
}
//test
  setLiveRegionLoadingState() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

    this.setLiveRegionText(this.loadingText);
    this.setAttribute('loading', true);
  }

  setLiveRegionText(statusText) {
    this.statusElement.setAttribute('aria-hidden', 'false');
    this.statusElement.textContent = statusText;

    setTimeout(() => {
      this.statusElement.setAttribute('aria-hidden', 'true');
    }, 1000);
  }
  normalizeSku(value) {
  return (value || '').toUpperCase().replace(/[^A-Z0-9]/g, '');
}

upgradeNativeResultImages() {
  if (!window.BE_SKU_INDEX || !this.predictiveSearchResults) return;

  const byHandle = {};

  Object.values(window.BE_SKU_INDEX).forEach((item) => {
    if (item.handle && item.image) {
      byHandle[item.handle] = item.image;
    }
  });

  const links = this.predictiveSearchResults.querySelectorAll('a[href*="/products/"]');

  links.forEach((link) => {
    if (link.closest('.be-exact-sku-match')) return;

    const href = link.getAttribute('href') || '';
    const handle = href.split('/products/')[1]?.split('?')[0]?.split('#')[0];

    if (!handle || !byHandle[handle]) return;

    const img = link.querySelector('img');
    if (!img) return;

    img.src = byHandle[handle];
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
  });
}

async loadSkuIndex() {
  if (window.BE_SKU_INDEX) return window.BE_SKU_INDEX;

  const response = await fetch('https://cdn.shopify.com/s/files/1/0798/0092/6444/files/sku-index.json?v=1780252902');
  window.BE_SKU_INDEX = await response.json();

  return window.BE_SKU_INDEX;
}

async addExactSkuMatch() {
  const searchTerm = this.getQuery();
  const key = this.normalizeSku(searchTerm);

  if (!key || !this.predictiveSearchResults) return;

  try {
    const index = await this.loadSkuIndex();

    const dashedKey = searchTerm.trim().toUpperCase();

let matches = index
  .map(item => {
    const sku = (item.sku || '').toUpperCase();
    const normalizedSku = this.normalizeSku(item.sku);

    let score = 0;

    if (sku === dashedKey) score = 100;
    else if (sku.startsWith(dashedKey + '-')) score = 90;
    else if (sku.startsWith(dashedKey)) score = 80;
    else if (normalizedSku.startsWith(key)) score = 50;

    return { ...item, beScore: score };
  })
  .filter(item => item.beScore > 0)
  .sort((a, b) => b.beScore - a.beScore);

    if (!matches.length) return;

    const list =
      this.predictiveSearchResults.querySelector('#predictive-search-results-products-list') ||
      this.predictiveSearchResults.querySelector('ul');

    if (!list) return;

    // Remove any old injected matches
    this.predictiveSearchResults.querySelectorAll('.be-exact-sku-match').forEach(el => el.remove());

    // Remove native duplicates for injected handles
    matches.forEach(match => {
      if (!match.handle) return;

      const duplicateNativeLinks = Array.from(
        this.predictiveSearchResults.querySelectorAll('a[href*="/products/"]')
      ).filter(a => {
        const href = a.getAttribute('href') || '';
        return href.includes('/products/' + match.handle) && !a.closest('.be-exact-sku-match');
      });

      duplicateNativeLinks.forEach(a => {
        const li = a.closest('li');
        if (li) li.remove();
      });
    });

    // Add matches in reverse order so final display order stays correct with prepend
    matches.slice().reverse().forEach(match => {
      if (!match.handle) return;

      const item = document.createElement('li');
      item.className = 'predictive-search__list-item be-exact-sku-match';

      item.innerHTML = `
<a href="/products/${match.handle}" class="predictive-search__item predictive-search__item--link predictive-search__item--link-with-thumbnail link link--text" tabindex="-1">

  ${match.image ? `
    <img
      src="${match.image}"
      alt="${match.title || match.sku}"
      class="predictive-search__image"
      loading="lazy"
    >
  ` : ''}

  <div class="predictive-search__item-content predictive-search__item-content--centered">

    <p class="predictive-search__item-heading h3">
      ${match.title || ''}
    </p>

    <span class="predictive-search__item-vendor" style="font-size:12px; color:#EE2E25">
      B&E Part# ${match.sku}
    </span>

  </div>

</a>
`;

      list.prepend(item);
    });
  } catch (e) {
    console.warn('B&E SKU dropdown lookup failed', e);
  }
}

  renderSearchResults(resultsMarkup) {
  this.predictiveSearchResults.innerHTML = resultsMarkup;
  this.setAttribute('results', true);

  this.addExactSkuMatch().then(() => {
  this.upgradeNativeResultImages();
  this.highlightMatchingTerms();
});

  this.setLiveRegionResults();
  this.open();
}

  setLiveRegionResults() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }

  getResultsMaxHeight() {
    this.resultsMaxHeight =
      window.innerHeight - document.querySelector('.section-header')?.getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }

  open() {
  this.predictiveSearchResults.style.maxHeight = '850px';
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }

  close(clearSearchTerm = false) {
    this.closeResults(clearSearchTerm);
    this.isOpen = false;
  }

  closeResults(clearSearchTerm = false) {
    if (clearSearchTerm) {
      this.input.value = '';
      this.removeAttribute('results');
    }
    const selected = this.querySelector('[aria-selected="true"]');

    if (selected) selected.setAttribute('aria-selected', false);

    this.input.setAttribute('aria-activedescendant', '');
    this.removeAttribute('loading');
    this.removeAttribute('open');
    this.input.setAttribute('aria-expanded', false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute('style');
  }
}

customElements.define('predictive-search', PredictiveSearch);